import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async"
import { useEffect } from 'react';
import useBackground from '../../../hooks/useBackground'
import useCommonTemplate from "../../../hooks/useCommonTemplate";

// CSSのimport
import './css/reset.scss';
import './css/style.scss';
import './css/sp_common.scss';
import './css/sp.scss';
import './css/demo.scss';
import './css/revealer.scss';
import './css/animate.scss';


// 画像import
import MV_img01 from './images/MV_img01.jpg';
import MV_img02 from './images/MV_img02.png';
import MV_img04 from './images/MV_img04.png';
import MV_img05 from './images/MV_img05.png';
import MV_img07 from './images/MV_img07.png';
import MV_img08 from './images/MV_img08.png';
import MV_img09 from './images/MV_img09.png';
import section01_img01 from './images/section01_img01.png';
import section01_img02 from './images/section01_img02.png';
import section02_img01 from './images/section02_img01.png';
import section02_img02 from './images/section02_img02.png';
import section02_img03 from './images/section02_img03.png';
import section02_img04 from './images/section02_img04.png';
import section02_img05 from './images/section02_img05.png';
import section02_img06 from './images/section02_img06.png';
import section02_img07 from './images/section02_img07.png';
import section02_para01 from './images/section02_para01.png';
import section02_para02 from './images/section02_para02.png';
import section03_img01 from './images/section03_img01.png';
import section03_img02 from './images/section03_img02.png';
import section03_img03 from './images/section03_img03.png';
import section03_img04 from './images/section03_img04.png';
import section03_img05 from './images/section03_img05.png';
import section03_img06 from './images/section03_img06.png';
import section03_img07 from './images/section03_img07.png';
import section03_img08 from './images/section03_img08.png';
import section03_img09 from './images/section03_img09.png';
import footer_img01 from './images/footer_img01.png';
import footer_img02 from './images/footer_img02.png';

type Props = {
}

const Index = (props: Props) => {

  /*=======================================
    背景操作用
  =======================================*/
  const background = useBackground();

  const commonTemplate = useCommonTemplate();
  commonTemplate.disable();

  useEffect(() => {
    background.activate();
    return () => {
      // 共通ヘッダーを有効化
      commonTemplate.enable();
    }
  }, []);

  useEffect(() => {
    // 100ms遅延してDOM描画を待つ
    const timeout = setTimeout(() => {
      // 必要なら外部JSを動的に読み込む
      const script = document.createElement('script');
      script.src = "https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js";
      script.async = true;
      document.body.appendChild(script);

      const wowScript = document.createElement('script');
      wowScript.src = "/sp/wataowa/js/wow.js";
      wowScript.async = true;
      document.body.appendChild(wowScript);

      wowScript.onload = () => {
        // @ts-ignore
        if (window.WOW) new window.WOW().init();
      };

      // touchstartイベント
      const touchHandler = () => { };
      document.addEventListener('touchstart', touchHandler);

      // 外部JSの動的読み込み
      const animeScript = document.createElement('script');
      animeScript.src = '/sp/wataowa/js/anime.min.js';
      animeScript.async = true;
      document.body.appendChild(animeScript);

      const scrollMonitorScript = document.createElement('script');
      scrollMonitorScript.src = '/sp/wataowa/js/scrollMonitor.js';
      scrollMonitorScript.async = true;
      document.body.appendChild(scrollMonitorScript);

      const mainScript = document.createElement('script');
      mainScript.src = '/sp/wataowa/js/main.js';
      mainScript.async = true;
      document.body.appendChild(mainScript);

      const revealerScript = document.createElement('script');
      revealerScript.src = '/sp/wataowa/js/revealer.js';
      revealerScript.async = true;
      document.body.appendChild(revealerScript);

      // クリーンアップ
      return () => {
        document.body.removeChild(script);
        document.body.removeChild(wowScript);
        document.removeEventListener('touchstart', touchHandler);
        document.body.removeChild(animeScript);
        document.body.removeChild(scrollMonitorScript);
        document.body.removeChild(mainScript);
        document.body.removeChild(revealerScript);
      };
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <Helmet>
        <title>わたしとキミの幸せな終末｜藍月なくる Story Album｜藍月なくる official site【公式サイト】</title>
        <meta property="og:title" content="わたしとキミの幸せな終末｜藍月なくる Story Album｜藍月なくる official site【公式サイト】" />

        <meta name="description" content="終末、どう過ごしますか？藍月なくるが贈る「わたしとキミの幸せな終末」特設サイト。クラリムステラ第一展示場 R-14。" />
        <meta property="og:description" content="終末、どう過ごしますか？藍月なくるが贈る「わたしとキミの幸せな終末」特設サイト。" />

        <meta property="og:url" content="https://aitsukinakuru.com/sp/wataowa/" />

        <meta property="og:image" content="https://aitsukinakuru.com/sp/wataowa/img/card.jpg"></meta>

        {/* <script>document.addEventListener('touchstart',function(){ });</script>
        <script src="/sp/wataowa/js/anime.min.js"></script>
        <script src="/sp/wataowa/js/scrollMonitor.js"></script>
        <script src="/sp/wataowa/js/main.js"></script>
        <script src="/sp/wataowa/js/revealer.js"></script> */}


        {/* Webフォント */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400..800;1,400..800&family=Noto+Serif+JP:wght@200..900&display=swap" rel="stylesheet" />


      </Helmet>
      {/* <motion.div
        initial={{ opacity: 0 }} // このページに遷移した直後
        animate={{ opacity: 1 }} // 最終的な状態
        exit={{ opacity: 0 }} // 離れる際にどうなるか
        transition={{ duration: 0.5 }} // 切り替えに要する時間
      >
        <main className="p__home">

        </main>
      </motion.div> */}

      <div className="special__happy_ending">
        <div className="js">
          <div className="loading">



            {/* <!--▼▼▼　フルスクリーンMV　▼▼▼--> */}
            <section id="main" className="wow fadeIn" data-wow-delay="1.4s">

              <div id="rev-1">
                <img src={MV_img01} width="1920" />
                <div className="mainvisual"></div>
              </div>

              <div id="MV_waku">
                <img src={MV_img04} className="wow fadeInLeft" data-wow-delay="3.4s" />
                <img src={MV_img05} className="wow fadeInRight" data-wow-delay="3.4s" />
              </div>


              <div id="main_illust">
                <p id="main01" className="wow fadeInDownB" data-wow-delay="2.9s"></p>
                <p id="main02" className="wow fadeInB" data-wow-delay="3.5s"><img src={MV_img07} width="810" /></p>
                <p id="main03" className="wow fadeInB" data-wow-delay="3.9s"><img src={MV_img08} width="320" /></p>
                <p id="main04" className="wow fadeInB" data-wow-delay="3.5s"><img src={MV_img09} width="1089" /></p>
              </div>


              <div id="flows">
                <div className="flow01"></div>
                <div className="flow02"></div>
                <div className="flow03"></div>
                <div className="flow04"></div>
                <div className="flow05"></div>
              </div>

            </section>
            {/* <!--▲▲▲　フルスクリーンMV　▲▲▲--> */}





            <main className="wow fadeIn" data-wow-delay="1.5s">





              {/* <!--▼▼▼　story　▼▼▼--> */}
              <section id="story">

                <dl id="story_catch" className="wow fadeInB">
                  <dt><img src={section01_img01} width="470" alt="終末、どう過ごしますか？" /></dt>
                  <dd><img src={section01_img02} width="467" alt="story" /></dd>
                </dl>

                {/* <!--▼▼▼　youtube　▼▼▼--> */}
                <div id="youtube">

                  {/* <iframe width="560" height="315" src="https://www.youtube.com/embed/NaPnltNA0AE?si=8VxRiUdrJi3quM6e" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/gjBG17sDoVY?si=WhO39rVKmhvcluFS" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

                </div>
                {/* <!--▲▲▲　youtube　▲▲▲--> */}

              </section>
              {/* <!--▲▲▲　story　▲▲▲--> */}






              {/* <!--▼▼▼　About　▼▼▼--> */}
              <div id="about">

                <div className="tracklist_cd wow fadeInDownMin" data-wow-delay="0.5s">
                  <img src={section02_img05} width="680" alt="CD" />
                </div>

                <div id="information"><div className="inner">

                  <h1><img src={section02_img01} width="605" alt="わたしとキミの幸せな終末" className="wow fadeInB" /></h1>
                  <h2><img src={section02_img02} width="111" alt="クラリムステラ" /></h2>

                  <ul className="tracklist_list">
                    <li><img src={section02_img03} width="221" alt="Track" /></li>
                    <li><img src={section02_img04} width="167" alt="Track" /></li>
                  </ul>

                  <div className="tracklist_info">
                    <dl>
                      <dt>INFORMATION</dt>
                      <dd>藍月なくる Story Album <br className="sp_inline" />"わたしとキミの幸せな終末"</dd>
                    </dl>
                    <dl>
                      <dt>SPEC</dt>
                      <dd>プレスCD/16Pフルカラージャケット/<br className="sp_inline" />ジュエルケース</dd>
                    </dl>
                    <dl>
                      <dt>NUMBERING</dt>
                      <dd>NRCD-09</dd>
                    </dl>
                    <dl>
                      <dt>RELEASE</dt>
                      <dd>2025/4/27 M3-2025春 <br className="sp_inline" />東京流通センター 第一展示場 R-14a,b</dd>
                    </dl>
                    <dl>
                      <dt>PRICE</dt>
                      <dd>イベント価格：2000円　<br className="sp_inline" />通販価格：各ショップ参照</dd>
                    </dl>
                    <dl>
                      <dt>SHOP</dt>
                      <dd>
                        <a href="https://www.melonbooks.co.jp/detail/detail.php?product_id=2916022" target="_blank"><span>メロンブックス</span></a>
                        <a href="https://www.diverse.direct/クラリムステラ/nrcd-09/" target="_blank"><span>Diverse Direct</span></a>
                      </dd>
                    </dl>
                    <dl>
                      <dt>SONG</dt>
                      <dd>全6曲入り</dd>
                    </dl>
                    <dl>
                      <dt>CIRCLE</dt>
                      <dd>クラリムステラ</dd>
                    </dl>
                  </div>

                  <div className="tracklist_book">
                    <dl>
                      <dt>BOOK</dt>
                      <dd>小説版「わたしとキミの幸せな終末」<br />
                        楽曲の世界背景が分かる短編小説集。<br />
                        （52P / A5 / 全6章 / カラーイラスト挿絵付き）<br />
                        イベント価格：1000円<br />
                        ※イベントで在庫が残った場合、後日通販予定。<br />
                        後日ダウンロード販売も予定しております。</dd>
                    </dl>
                  </div>

                </div></div>

                <div className="tracklist_book">
                  <img src={section02_img06} width="270" alt="本" className="wow fadeInB" data-wow-delay="0.3s" />
                  <img src={section02_img07} width="353" alt="本" className="wow fadeInDownB" data-wow-delay="0.8s" />
                </div>

                <img src={section02_para01} width="601" className="fw01" />
                <img src={section02_para02} width="796" className="fw02" />

              </div>
              {/* <!--▲▲▲　About　▲▲▲--> */}















              {/* <!--▼▼▼　Staff　▼▼▼--> */}
              <section id="staff">
                <div className="inner">
                  <img src={section03_img01} width="367" alt="ヘイマルメネー" className="wow fadeInB" />
                  <img src={section03_img02} width="227" alt="アンチテール" className="wow fadeInB" />
                  <img src={section03_img03} width="183" alt="ミスリルドロップ" className="wow fadeInB" />
                  <img src={section03_img04} width="189" alt="Predatory" className="wow fadeInB" />
                  <img src={section03_img05} width="198" alt="Seed of Fate" className="wow fadeInB" />
                  <img src={section03_img06} width="228" alt="軌跡" className="wow fadeInB" />
                  <img src={section03_img07} width="223" alt="マスタリング" className="wow fadeInB" />
                  <img src={section03_img08} width="258" alt="スタッフ" className="wow fadeInB" />
                  <img src={section03_img09} width="158" alt="プロデュース" className="wow fadeInB" />
                </div>
              </section>
              {/* <!--▲▲▲　Staff　▲▲▲--> */}







              {/* <!--▼▼▼　Footer　▼▼▼--> */}
              <section id="happy_ending_footer">
                <img src={footer_img01} width="90" alt="クラリムステラ" />
                <img src={MV_img02} width="222" alt="A happy ending for you and me" />
                <div><img src={footer_img02} width="167" alt="Copyright 2025 Qulalimstella" /></div>
              </section>
              {/* <!--▲▲▲　Footer　▲▲▲--> */}





            </main>



          </div>
        </div>
      </div>









    </>
  );
}
export default Index;